import React from 'react'
import { FieldControl } from 'spark-core-dx/components';
import { SystemTypes } from 'spark-core-dx/services';
import { useVisualFormContext } from '../../../contexts/VisualFormContext';

export const VisualType = ({ visualTypes }) => {
    const convertedVisualTypes = visualTypes?.map(item => ({
        Text: item.FriendlyName,
        Value: item._id
    }));


    const { visualObject, setVisualObject } = useVisualFormContext();

    return (
        <FieldControl
            fieldMetadata={{
                FieldType: SystemTypes.UIFieldType.SearchSelectList,
                DisplayName: "Visual Type",
                FieldName: "VisualTypeId",
                IsRequired: true,
            }}
            selectData = {convertedVisualTypes}
            groupId={"visual"}
            value={visualObject?.VisualTypeId}
            onChange={(v) => {
                setVisualObject(prev => ({
                    ...prev,
                    VisualTypeId: v,
                }));
            }}
        />
    )
}